/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlannerAppToolCallResponse
 */
export interface PlannerAppToolCallResponse {
    /**
     * 
     * @type {Array<object>}
     * @memberof PlannerAppToolCallResponse
     */
    content: Array<object>;
    /**
     * 
     * @type {object}
     * @memberof PlannerAppToolCallResponse
     */
    structuredContent?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlannerAppToolCallResponse
     */
    isError: boolean;
}

/**
 * Check if a given object implements the PlannerAppToolCallResponse interface.
 */
export function instanceOfPlannerAppToolCallResponse(value: object): value is PlannerAppToolCallResponse {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('isError' in value) || value['isError'] === undefined) return false;
    return true;
}

export function PlannerAppToolCallResponseFromJSON(json: any): PlannerAppToolCallResponse {
    return PlannerAppToolCallResponseFromJSONTyped(json, false);
}

export function PlannerAppToolCallResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerAppToolCallResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
        'structuredContent': json['structured_content'] == null ? undefined : json['structured_content'],
        'isError': json['is_error'],
    };
}

export function PlannerAppToolCallResponseToJSON(json: any): PlannerAppToolCallResponse {
    return PlannerAppToolCallResponseToJSONTyped(json, false);
}

export function PlannerAppToolCallResponseToJSONTyped(value?: PlannerAppToolCallResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'structured_content': value['structuredContent'],
        'is_error': value['isError'],
    };
}

